import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TopPicks } from '../components/TopPicks';
import { FeaturedExperts } from '../components/FeaturedExperts';
import { ActiveAgents } from '../components/ActiveAgents';
import { StatsSection } from '../components/StatsSection';
export function MostPopularPage() {
  useEffect(() => {
    document.title = 'Most Popular AI Shopping Assistants | ShoppingExpert.ai';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Discover the most popular AI shopping assistants, expert advisors, and active agents. Top-rated tools for fashion, travel, electronics, and more.');
    }
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-slate-50" data-id="element-954">
      {/* Header */}
      <header className="sticky top-0 z-10 backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/90 border-b border-slate-200" data-id="element-955">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4" data-id="element-956">
          <div className="flex items-center justify-between" data-id="element-957">
            <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-958">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4yJ3FscyPfrN1xAm7crLNW/ChatGPT_Image_Dec_2%2C_2025%2C_10_42_07_PM.png" alt="Shopping Expert.ai Logo" className="h-12 object-contain" data-id="element-959" />
              <div data-id="element-960">
                <span className="text-xl font-bold text-slate-900" data-id="element-961">
                  AI Shopping Expert
                </span>
                <p className="text-xs text-slate-500" data-id="element-962">
                  Most Popular AI Shopping Assistants
                </p>
              </div>
            </Link>
            <nav className="hidden md:flex items-center gap-4 text-sm" data-id="element-963">
              <Link to="/" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-964">
                Home
              </Link>
              <Link to="/most-popular-ai-shopping-assistants" className="text-slate-900 font-semibold border-b-2 border-slate-900 pb-1" data-id="element-965">
                Most Popular
              </Link>
              <Link to="/research" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-966">
                Research
              </Link>
              <Link to="/about" className="text-slate-600 hover:text-slate-900 font-medium" data-id="element-967">
                About
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto max-w-7xl px-4 sm:px-6 py-12" data-id="element-968">
        <div className="text-center mb-12" data-id="element-969">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-970">
            Most Popular AI Shopping Assistants
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-971">
            Discover the top-rated AI shopping assistants, expert advisors, and
            active agents trusted by millions of shoppers worldwide.
          </p>
        </div>

        {/* Stats Section */}
        <StatsSection data-id="element-972" />

        {/* Top Shopping GPTs */}
        <TopPicks data-id="element-973" />

        {/* Featured Expert Advisors */}
        <FeaturedExperts data-id="element-974" />

        {/* Active AI Shopping Agents */}
        <ActiveAgents data-id="element-975" />

        {/* CTA Section */}
        <div className="mt-16 p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200 text-center" data-id="element-976">
          <h2 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-977">
            Explore the Full Directory
          </h2>
          <p className="text-slate-700 mb-6 max-w-2xl mx-auto" data-id="element-978">
            Browse 100+ verified AI shopping assistants across all categories.
            Find the perfect tool for your shopping needs.
          </p>
          <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-slate-900 text-white rounded-xl font-semibold hover:bg-black transition-colors" data-id="element-979">
            View Full Directory →
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white mt-16" data-id="element-980">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-8" data-id="element-981">
          {/* Our Review Method */}
          <div className="mb-8 p-6 rounded-2xl bg-gradient-to-br from-blue-50 to-cyan-50 border-2 border-blue-200" data-id="element-982">
            <h3 className="text-xl font-bold text-slate-900 mb-3 text-center" data-id="element-983">
              Our Review Method
            </h3>
            <p className="text-sm text-slate-700 mb-4 text-center" data-id="element-984">
              How We Evaluate AI Agents
            </p>
            <p className="text-sm text-slate-700 mb-4 text-center" data-id="element-985">
              Every agent on ShoppingExpert.ai passes a strict, Trustpilot-style
              review:
            </p>
            <div className="flex flex-wrap justify-center gap-2 mb-4" data-id="element-986">
              {['Accuracy of recommendations', 'Transparency & reliability', 'Real product knowledge', 'Consistency across categories', 'User satisfaction signals'].map((item, idx) => <span key={idx} className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white border border-blue-200 text-slate-700 text-xs font-medium" data-id="element-987">
                  <span className="text-green-600 font-bold" data-id="element-988">✓</span>
                  {item}
                </span>)}
            </div>
            <p className="text-sm text-slate-900 font-bold text-center" data-id="element-989">
              If it doesn't meet our standard — it doesn't get listed.
            </p>
          </div>

          <div className="text-center mb-4" data-id="element-990">
            <p className="text-sm font-semibold text-slate-900 mb-1" data-id="element-991">
              ShoppingExpert.ai
            </p>
            <p className="text-xs text-slate-600" data-id="element-992">
              The independent directory of AI Shopping Agents & Sales Advisors.
            </p>
            <p className="text-xs text-slate-600" data-id="element-993">
              Updated weekly. Curated by ShoPilots.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500" data-id="element-994">
            <div data-id="element-995">© 2025 ShoppingExpert.ai • All rights reserved</div>
            <div className="flex items-center gap-3" data-id="element-996">
              <Link to="/about" className="underline" data-id="element-997">
                About
              </Link>
              <Link to="/faq" className="underline" data-id="element-998">
                FAQ
              </Link>
              <Link to="/contact" className="underline" data-id="element-999">
                Contact
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}